export default __webpack_public_path__ + "static/media/0000..0006.e5c1d164.png";